
import React, { createContext, useEffect, useState } from 'react';
import { useCentralApi, useCurrentUser } from 'hooks/shared';
import IAccountPermissions from 'models/accounts/IAccountPermissions';

const AccountPermissionsContext = createContext<IAccountPermissions | null>(null);
const AccountPermissionsConsumer = AccountPermissionsContext.Consumer;

const AccountPermissionsProvider = (props: { children?: React.ReactNode }) => {
    const [ value, setValue ] = useState<IAccountPermissions | null>(null);
    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    useEffect(() => {
        const controller = new AbortController();
        (async () => {
            if (user && user.access_token) {
                try {
                    const resp = await fetcher('/api/v3/accounts/permissions', {
                        signal: controller.signal
                    });

                    if (!resp.ok) {
                        // do something
                    }

                    const result = await resp.json() as IAccountPermissions;
                    setValue(result);
                } catch (err) {
                    
                }
            }
        })();

        return () => controller.abort();
    }, [ user ]);

    return (
        <AccountPermissionsContext.Provider value={value}>
            {props.children}
        </AccountPermissionsContext.Provider>
    );
};

export default AccountPermissionsProvider;
export {
    AccountPermissionsConsumer,
    AccountPermissionsContext
};